import * as React from 'react';
import * as styles from './styles/index.css';

import { getHighlighted, getIndicesOf } from '../../utils/text';

export interface IHighlighterProps extends React.HTMLProps<HTMLElement> {
  value: string;
  term: string;
  description?: string;
  AsElement?: keyof JSX.IntrinsicElements;
  dataMark?: string;
  onlyFirstInstance?: boolean;
}

export function Lighter(props: { children: React.ReactNode | React.ReactNode[]}): JSX.Element {
  return (
    <span className={styles['bold']}>{props.children}</span>
  );
}

export function Highlighter(props: IHighlighterProps) {
  // tslint:disable-next-line:no-any
  const { AsElement = 'div' as any, value, term, description, dataMark, onlyFirstInstance, ...restProps } = props;
  const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // escape для спецсимволов

  let indices = getIndicesOf(value, escapedTerm, onlyFirstInstance);

  const highlighted = getHighlighted(value, indices, escapedTerm.length, Lighter);

  return (
    <AsElement data-mark={dataMark || 'Highlighter'} {...restProps}>
      <span>
        {highlighted}
      </span>
      { description &&
        <div className={styles['description']}>
          {description}
        </div>
      }
    </AsElement>
  );
}
